import Settings from 'src/Settings';
import RedesignDescriptor from './header-redesign';
import RefiveDescriptor from './header-refive';
import CanteenDescriptor from './header-canteen';
import CompanyKitchenDescriptor from './header-companykitchen';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getHeaderDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
